import React from 'react'
import styles from './action-history.module.scss'
import { Icon } from '@iconify/react'
import { Button } from 'antd'

type Props = {
  onUndo: () => void
  onRedo: () => void
  isUndoDisabled: boolean
  isRedoDisabled: boolean
  isLoading: boolean
  hide?: boolean
}

export const ActionHistory = React.memo(
  ({ onUndo, onRedo, isUndoDisabled, isRedoDisabled, isLoading, hide = false }: Props) => {
    if (hide) return null
    return (
      <div className={styles.container}>
        <Button
          icon={<Icon icon='lucide:undo' />}
          disabled={isUndoDisabled || isLoading}
          onClick={onUndo}
          className={styles.button}
        />
        <Button
          icon={<Icon icon='lucide:redo' />}
          disabled={isRedoDisabled || isLoading}
          onClick={onRedo}
          className={styles.button}
        />
      </div>
    )
  },
)
